<template>
	<section class="ticket_get">
		<Nav title="领券中心" />
		<img :src="ticketBg" class="ticket_bg1" onerror="onerror=null; src='https://oss.kkqd.vip/baiboss/2022212/3mber5bqai/sd_ticket_bg.png'">
		<section v-if="isData" class="list">
			<img src="../../../assets/img/ticket_bg2.png" class="ticket_bg2">
				<div class="item" v-for="item in list" :key="item.id">
					<div class="item_info">
						<img src="../../../assets/img/ticket_bg_a.png" class="bg">
						<div class="left">
							<div class="left_info">
								<div v-if="item.couponType == 0"><p>{{item.couponDenomination}}</p><span>币</span></div>
								<div v-else-if="item.couponType == 1"><p>{{item.couponDenomination/100}}</p><span>元</span></div>
								<div v-else-if="item.couponType == 2"><p>{{(item.couponDenomination*10).toFixed(1)}}</p><span>折</span></div>
								<i v-if="item.ruleType == 0">注册后可领取</i>
								<i v-else-if="item.ruleType == 1">认证通过后可领取</i>
								<i v-else-if="item.ruleType == 2">首充后可领取</i>
							</div>
						</div>
						<div class="right">
							<h3>{{item.couponName}}</h3>
							<p class="time" v-if="token">{{item.receiveEndTime}}前可领</p>
							<p class="time" v-else>登录后查看任务有效期</p>
							<div v-if="item.status==2">
								<p class="select_itme_ed">已领取</p>
							</div>
							<div v-else-if="item.status==3">
								<p class="select_itme_ed select_itme_fail">已失效</p>
							</div>
							<div v-else>
								<p class="select_itme" v-if="!token" @click="showloginModel">立即领取</p>
								<p class="select_itme" v-if="token && !isApprove && item.ruleType==1" @click="skipView">去认证</p>
								<p class="select_itme" v-if="token && !isApprove && item.ruleType==2" @click="skipView">去认证</p>
								<p class="select_itme" v-if="token && !isApprove && item.ruleType==0" @click="selectFn(item.userCouponId)">立即领取</p>
								<p class="select_itme" v-if="token && isApprove && item.ruleType==2 && item.status==0" @click="skipFull">去充值</p>
								<p class="select_itme" v-if="token && isApprove && item.ruleType==2 && item.status==1" @click="selectFn(item.userCouponId)">立即领取</p>
								<p class="select_itme" v-if="token && isApprove && item.ruleType!=2" @click="selectFn(item.userCouponId)">立即领取</p>
							</div>
						</div>
					</div>
				</div>
		</section>
	</section>
</template>

<script>
import Nav from "components/Nav"
import ticketServer from "api/ticket";
import orderServer from "api/order";
import Login from "components/Login";
import { Notify, Dialog } from 'vant';


export default {
	name: 'ticket-index',
	components: {
		Nav,
		Login
	},
	data() {
		return {
			loading: false,
			finished: false,
			list: [],
			isData: true,
			params: {
				pageNum: 0,
				pageSize: 10,
			},
			isLoginModel: false,
			topLeftArrow: true,
			type:'login',
			isApprove: 1,
			token: '',
			startTime: '',
			endTime: '',
			ticketBg: 'https://oss.kkqd.vip/baiboss/2022212/4wayqor9j9/sd_ticket_bg.png'
		}
	},
	created() {
		this.token = localStorage.getItem('token')
		if(this.token) {
		// 	//获取认证状态
			this.getApproveStatus()
			this.getActivityY()
		}else {
			this.getActivityN()
		}
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getSearchTask() {
			ticketServer.SearchTask({activityId:1}).then((res) => {
				this.startTime = res.data.activityStartTime
				this.endTime = res.data.activityEndTime
			})
		},
		loadMore() {
			this.loading = true
			this.params.pageNum++
			ticketServer.FullDetail(this.params).then((res) => {
				if(this.params.pageNum == 1) {
					if(!res.data.list || res.data.list.length==0) {
						this.isData = 0
					}
				}
				this.list = this.list.concat(res.data.list) 
				this.loading = false
				if(res.data.list.length<20) {
					this.finished = true
				}
			})
		},
		showRuleInfo(i) {
			if(this.list[i].show) {
				this.list[i].show = 0
			}else {
				this.list[i].show = 1
			}
			
		},
		selectFn(id) {
			ticketServer.GetTicket({userCouponId: id}).then((res) => {
				Dialog.confirm({ 
					title: '领取成功', 
					message: '恭喜你，领取成功，\n请在「我的-优惠券」中查看和使用', 
					confirmButtonText: '去查看',
					cancelButtonText: '确定',
				}).then(() => { 
					this.$router.push({name: 'ticket-index'})
				}).catch(() => {
					this.getActivityY()
				});
			})
		},
		skipView() {
			this.$router.push({name: 'attestation'})
		},
		skipFull() {
			this.$router.push({name: 'full'})
		},
		getActivityY() {
			ticketServer.SearchActivityY({activityId: 1}).then((res) => {
				this.list = res.data
			})
		},
		getActivityN() {
			ticketServer.SearchActivityN({activityId: 1}).then((res) => {
				this.list = res.data
			})
		},
		// ------------- login -------------
		getApproveStatus() {
			orderServer.AuthStatus().then((res) => {
				if(res.data.status == 20) {
					this.isApprove = 1
				}else {
					this.isApprove = 0
				}
				console.log(this.isApprove);
			})
			
		},
		// 登录提示：抢单停止，改为推单模式
		showloginModel() {
			Dialog.confirm({
				title: '提示',
				message: '抢单模式已停止。现变更为推单模式。如需开通推送账户，请扫码添加客服开通。',
				confirmButtonText: '联系客服',
				cancelButtonText: '确认',
			}).then(() => {
				this.$router.push({ name: 'kefu' })
			}).catch(() => {
				// 点击"确认"，仅关闭弹窗，终止后续流程
			})
		},
		// loginModelFn(type) {
		// 	if(type == 'login') {
		// 		this.topLeftArrow= true
		// 	}else {
		// 		this.topLeftArrow= false
		// 	}
		// 	this.type = type
		// 	this.isLoginModel = true
		// },
		// loginStatus(status) {
		// 	if(status == 'ok') {
		// 		this.token = 1
		// 		this.isLoginModel = false
		// 		this.getApproveStatus()
		// 		this.getActivityY()
		// 	}
		// },
	}
}
</script>

<style lang="scss">
	.ticket_get {
		position: relative;
		padding-top: 46px;
		.ticket_bg1 {
			width: 100%;
			display: block;
		}
		.hodong_time {
			position: absolute;
			top: 150px;
			left: 50%;
			transform: translateX(-50%);
			color: #3A5EEC;
			font-size: 15px;
		}
		.list {
			position: relative;
			padding: 19px 18px;
			img {
				display: block;
			}

			.ticket_bg2 {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}

			.history {
				display: flex;
				justify-content: center;
				align-items: center;
				color: #7D8290;
				font-size: 14px;
				padding: 4px 0;
				img {
					width: 7px;
					margin-left: 5px;
				}
			}
			.item {
				position: relative;
				margin-bottom: 24px;

				.rule_info {
					width: 100%;
					margin-top: -5px;
					padding: 8px 11px;
					padding-top: 14px;
					border: 1Px solid #7E92E2;
					border-radius: 4px;
					border-top-left-radius: 0;
					border-top-right-radius: 0;
					border-top: 0;
					p {
						font-size: 12px;
						color: #7D8290;
					}
				}
			}
			.item_info {
				position: relative;
				width: 100%;
				height: 102px;
				.bg {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
				}
				.left {
					position: absolute;
					width: 108px;
					height: 100%;
					top: 0;
					left: 0;
					z-index: 2;
					.left_info {
						position: absolute;
						top: 50%;
						left: 50%;
						width: 100%;
						transform: translate(-50%, -50%);
						div {
							text-align: center;
							p {
								display: inline-block;
								font-size: 28px;
								font-weight: bold;
								color: #3A5EEC;
							}
							span {
								display: inline-block;
								color: #3A5EEC;
								font-weight: bold;
								font-size: 12px;
								vertical-align: text-bottom;
							}
						}
						i {
							display: block;
							text-align: center;
							font-style: normal;
							font-size: 12px;
							color: #3A5EEC;
							transform: scale(.9);
						}
					}
				}
				.right {
					position: absolute;
					height: 100%;
					width: 231px;
					top: 0;
					left: 108px;
					z-index: 2;
					padding-top: 15px;
					padding-left: 12px;
					padding-bottom: 9px;
					h3 {
						font-size: 14px;
						color: #2B2F3A;
						font-weight: bold;
					}
					.time {
						color: #A2A6AE;
						font-size: 12px;
					}
					.rule_btn {
						margin-top: 20px;
						padding-top: 6px;
						color: #A2A6AE;
						font-size: 12px;
						display: flex;
						align-items: center;
						img {
							width: 10px;
							margin-left: 2px;
						}
					}
					.select_itme, .select_itme_ed {
						position: absolute;
						right: 9px;
						bottom: 9px;
						width: 70px;
						height: 26px;
						line-height: 26px;
						text-align: center;
						color: #fff;
						font-size: 12px;
						background: #3A5EEC;
						border-radius: 20px;
					}
					.select_itme_ed {
						color: #3A5EEC;
						background: #E1F7FE;
					}
					.select_itme_fail {
						background: #EFF0F4;
						color: #7D8290;
					}
				}

			}
		}
		.nodata_class {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			img {
				width: 92px;
				margin: 0 auto;
			}
			p {
				color: #7D8290;
				font-size: 14px;
				text-align: center;
				padding-top: 11px;
				padding-bottom: 41px;
			}
			h4 {
				width: 127px;
				height: 36px;
				line-height: 36px;
				text-align: center;
				color: #fff;
				font-size: 14px;
				font-weight: bold;
				border-radius: 20px;
				background: #3A5EEC;
			}

		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/ticket/Get.vue